import { useEffect } from 'react';
import { Portal } from './Portal';

export default function BottomSheet({ children, height = 90 }: { children: JSX.Element; height?: number }) {
  useEffect(() => {
    document.body.style.height = '100%';
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.height = '100%';
      document.body.style.overflow = 'auto';
    };
  }, []);
  return (
    <Portal>
      <div className="relative w-screen h-screen flex items-end">
        <div className="absolute top-0 left-0 w-full h-full bg-black/40 -z-10"></div>
        <div
          style={{ height: `${height}%` }}
          className={`w-full animate-emerge-from bg-white flex flex-col items-center z-40 rounded-t-3xl overflow-hidden`}
        >
          {children}
        </div>
      </div>
    </Portal>
  );
}
